type Func = () => void;

export default (fns: Func[]): void => {
  const uniqueFns = Array.from(new Set(fns));
  uniqueFns.forEach((fn) => fn());
};
